/**
 * Product configuration. Everything commercial lives here so you can tune the
 * offer without touching the pipeline.
 */
export const PRODUCT = {
    // Named for what it does. The site's own brand comes from the platform
    // header, so the tool does not carry a second product name.
    name: 'Background Remover',
    tagline: 'Remove image backgrounds, privately',
    /** Shown everywhere. This is literally true for this build -- see README. */
    privacyClaim: 'Your image never leaves your device.',
};
export const PAYPAL = {
    /**
     * Your PayPal.me handle -- just the username, no URL.
     * e.g. 'janedoe' produces https://www.paypal.com/paypalme/janedoe/1
     *
     * IMPORTANT: apply for PayPal **Micropayments** pricing on your business
     * account before launching. On a $1.00 sale standard rates take ~$0.52 while
     * micropayments rates take ~$0.14. Verify current rates for your country.
     */
    handle: 'YOUR_PAYPAL_HANDLE',
    price: '1.00',
    currency: 'USD',
};
export function paypalUrl() {
    const { handle, price, currency } = PAYPAL;
    return `https://www.paypal.com/paypalme/${encodeURIComponent(handle)}/${price}${currency}`;
}
export const isPaypalConfigured = () => PAYPAL.handle !== 'YOUR_PAYPAL_HANDLE';
/** Longest-edge cap on the exported PNG, per tier. */
export const TIERS = {
    free: {
        id: 'free',
        label: 'Free',
        maxEdge: 1200,
        /** Clean up the grey haze around edges. Cheap, helps every image. */
        tightenEdges: true,
        /** Remove old-background colour bleeding into semi-transparent pixels. */
        decontaminate: false,
    },
    hd: {
        id: 'hd',
        label: 'HD',
        /** 0 = no cap, export at the source resolution. */
        maxEdge: 0,
        tightenEdges: true,
        decontaminate: true,
    },
};
/**
 * Honour-system unlock.
 *
 * With PayPal.me (no API) there is no way to verify payment server-side, so
 * this flag is the whole gate. That is a deliberate trade-off: because all
 * processing happens in the visitor's browser, somebody bypassing it costs us
 * exactly nothing -- no GPU, no bandwidth, no server. We forgo revenue from
 * people who were never going to pay; we do not lose money.
 *
 * If revenue later justifies it, the upgrade path is PayPal Orders API +
 * webhook with server-side HD rendering. See README.
 */
const UNLOCK_KEY = 'cutout.hd.unlocked';
export const unlock = {
    isUnlocked() {
        try {
            return localStorage.getItem(UNLOCK_KEY) === '1';
        }
        catch {
            return false; // private mode / storage blocked
        }
    },
    grant() {
        try {
            localStorage.setItem(UNLOCK_KEY, '1');
        }
        catch {
            /* non-fatal: unlock just won't persist across reloads */
        }
    },
    revoke() {
        try {
            localStorage.removeItem(UNLOCK_KEY);
        }
        catch {
            /* ignore */
        }
    },
};
